<div class="row">
    <div class="col-sm-12">
        <div class="content-header mt-0 mb-2">{{'edit-profile' | translate}}</div>
    </div>
</div>
<form class="form" #form="ngForm" (ngSubmit)="save()">
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }"></ngx-loading>
                <div class="card-body">
                    <div class="px-3">
                        <div class="form-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="firstname">{{'firstname' | translate}}</label>
                                        <input type="text" id="firstname" class="form-control" name="firstname" [(ngModel)]="model.firstname" required>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lastname">{{'lastname' | translate}}</label>
                                        <input type="text" id="lastname" class="form-control" name="lastname" [(ngModel)]="model.lastname" required>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="email">E-Mail</label>
                                        <input type="text" id="email" class="form-control" name="email" [(ngModel)]="model.email" readonly>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="address">{{'address' | translate}}</label>
                                <textarea id="address" rows="5" class="form-control" name="address" [(ngModel)]="model.address"></textarea>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="city">{{'city' | translate}}</label>
                                        <input type="text" id="city" class="form-control" name="city" [(ngModel)]="model.city">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="zipCode">{{'zipCode' | translate}}</label>
                                        <input type="text" id="zipCode" class="form-control" name="zipCode" [(ngModel)]="model.zipCode">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="mobile">{{'mobile' | translate}}</label>
                                        <input type="text" id="mobile" class="form-control" name="mobile" [(ngModel)]="model.mobile">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button type="submit" class="btn btn-raised btn-primary" [disabled]="form.invalid || !passwordsMatch()">
                                <i class="fa fa-check-square-o"></i> {{'save' | translate}}
                            </button>
                            <span class="ml-1 text-success" *ngIf="isSaved">Profil wurde gespeichert.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card">
                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }"></ngx-loading>
                <div class="card-body">
                    <div class="px-3">
                        <div class="form-body">
                            <h4 class="form-section"><i class="fa fa-lock"></i> {{'password' | translate}}</h4>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="password">{{'new_password' | translate}}</label>
                                        <input type="password" id="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" minlength="6" maxlength="50">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="passwordRepeat">{{'repeat_password' | translate}}</label>
                                        <input type="password" id="passwordRepeat" class="form-control" name="passwordRepeat" [(ngModel)]="passwordRepeat" minlength="6" maxlength="50">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }"></ngx-loading>
                <div class="card-body">
                    <div class="px-3">
                        <div class="form-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group mt-3">
                                        <ui-switch name="receiveMessageAsMail" [(ngModel)]="model.receiveMessageAsMail"></ui-switch> {{'receive_as_mail' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="model && hasOutOfOffice(model)">
                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '4px' }"></ngx-loading>
                <div class="card-body">
                    <div class="px-3">
                        <div class="form-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group mt-3">
                                        <ui-switch name="outOfOffice" [(ngModel)]="model.outOfOffice"></ui-switch> Abwesenheitsnotiz einschalten
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="outOfOfficeText">Text</label>
                                        <textarea id="outOfOfficeText" rows="5" class="form-control" name="outOfOfficeText" [(ngModel)]="model.outOfOfficeText"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>


// WEBPACK FOOTER //
// ./src/app/users/profile-edit/profile-edit.component.html